enum UserAccess {
  APP_USER = "APP_USER",
  CARDHOLDER = "CARDHOLDER",
  VERIFICATION_ONLY = "VERIFICATION_ONLY",
  INACTIVE = "INACTIVE",
}

export default UserAccess;
